import { Mail } from 'lucide-react';

import { Icon } from '@/_components';

import { getInvoiceEmailAriaLabel } from './invoice-email-aria-label';
import { InvoiceEmailHistoryTooltip } from './invoice-email-history-tooltip';
import { InvoiceEmailStatusBadge } from './invoice-email-status-badge';

import { deriveInvoiceEmailBadge } from '../derive-invoice-email-badge';
import { hasParentBillingContact } from '../has-parent-billing-contact';
import type { InvoiceQuerySchema } from '../schemas/invoices/invoice-query-schema';

export const INVOICE_NOT_EMAILABLE_MESSAGE =
  'No billing contact on the parent agreement - this invoice cannot be emailed.';

type InvoiceEmailActionsCellProps = {
  invoice: InvoiceQuerySchema;
  onOpenSendModal: () => void;
};

export function InvoiceEmailActionsCell({ invoice, onOpenSendModal }: InvoiceEmailActionsCellProps) {
  const canEmail = hasParentBillingContact(invoice);
  const badgeState = deriveInvoiceEmailBadge(invoice);
  const ariaLabel = getInvoiceEmailAriaLabel(invoice.invoice_number, badgeState);

  return (
    <div className="flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
      <InvoiceEmailHistoryTooltip
        invoice={invoice}
        canLoadHistory={canEmail}
        tooltipWhenDisabled={INVOICE_NOT_EMAILABLE_MESSAGE}
      >
        <button
          type="button"
          className="text-c-card-muted hover:text-c-foreground relative inline-flex size-8 cursor-pointer items-center justify-center rounded-md hover:bg-gray-100 disabled:cursor-not-allowed dark:hover:bg-gray-800"
          aria-label={ariaLabel}
          aria-disabled={!canEmail}
          disabled={!canEmail}
          onClick={(e) => {
            e.stopPropagation();
            if (!canEmail) {
              return;
            }
            onOpenSendModal();
          }}
        >
          <Icon icon={Mail} className="size-4 shrink-0" />
          <InvoiceEmailStatusBadge state={badgeState} />
        </button>
      </InvoiceEmailHistoryTooltip>
    </div>
  );
}
